/* ==========================================================================
   MIHAICR — theme.js
   JavaScript vanilla, fara dependinte externe.
   Fiecare modul este independent si se initializeaza doar daca
   elementele corespunzatoare exista in DOM.
   ========================================================================== */

(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animationsOff = document.documentElement.classList.contains('no-animations');
  var motionOK = !prefersReduced && !animationsOff;

  /* ------------------------------------------------------------------------
     Helper-e
     ------------------------------------------------------------------------ */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait || 150);
    };
  }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return value.replace('.', ',');
  }

  /* ------------------------------------------------------------------------
     1. SCROLL REVEAL
     ------------------------------------------------------------------------ */
  function initReveal() {
    var items = $$('.reveal');
    if (!items.length) return;

    if (!motionOK || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    items.forEach(function (el, i) {
      // Delay in cascada pentru elementele din aceeasi grila
      if (!el.style.getPropertyValue('--reveal-delay')) {
        var parent = el.parentElement;
        var index = parent ? Array.prototype.indexOf.call(parent.children, el) : i;
        el.style.setProperty('--reveal-delay', Math.min(index, 8) * 70 + 'ms');
      }
      observer.observe(el);
    });
  }

  /* ------------------------------------------------------------------------
     2. HEADER STICKY
     ------------------------------------------------------------------------ */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;

    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 20);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ------------------------------------------------------------------------
     3. MENIU MOBIL
     ------------------------------------------------------------------------ */
  function initMobileMenu() {
    var menu = $('[data-mobile-menu]');
    var openBtns = $$('[data-menu-open]');
    var closeBtns = $$('[data-menu-close]');
    if (!menu || !openBtns.length) return;

    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      // Delay in cascada pentru linkuri
      $$('.mobile-menu__link', menu).forEach(function (link, i) {
        link.style.animationDelay = (80 + i * 55) + 'ms';
      });
      var first = $('a, button', menu);
      if (first) first.focus();
    }

    function close() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
      if (lastFocused) lastFocused.focus();
    }

    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
    });

    // Submeniuri in mobile
    $$('[data-mobile-sub-toggle]', menu).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        if (!panel) return;
        var open = panel.hasAttribute('hidden');
        if (open) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ------------------------------------------------------------------------
     4. PANOU DE CAUTARE
     ------------------------------------------------------------------------ */
  function initSearch() {
    var panel = $('[data-search-panel]');
    if (!panel) return;

    var input = $('input[type="search"]', panel);

    function open() {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      if (input) setTimeout(function () { input.focus(); }, 120);
    }

    function close() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
    }

    $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', close); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
      // Ctrl/Cmd + K deschide cautarea
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        panel.classList.contains('is-open') ? close() : open();
      }
    });

    // Sugestii predictive folosind Shopify Predictive Search API
    var results = $('[data-search-results]', panel);
    if (!input || !results) return;

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }

      var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') +
        'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6';

      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];

          if (!products.length && !collections.length) {
            results.innerHTML = '<p class="text-muted mt-2">' + (results.dataset.empty || 'Niciun rezultat.') + '</p>';
            return;
          }

          var html = '<div class="grid grid--3 mt-4">';
          products.forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
            html += '<a class="surface card anim-fade-up" href="' + p.url + '">' +
              '<span class="card__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="400" height="300">' : '') + '</span>' +
              '<span class="card__body"><span class="card__title">' + p.title + '</span>' +
              '<span class="price"><span class="price__current">' + (p.price ? formatMoney(p.price) : '') + '</span></span></span></a>';
          });
          html += '</div>';

          if (collections.length) {
            html += '<div class="search-panel__suggestions">';
            collections.forEach(function (c) {
              html += '<a class="chip" href="' + c.url + '">' + c.title + '</a>';
            });
            html += '</div>';
          }

          results.innerHTML = html;
        })
        .catch(function () { results.innerHTML = ''; });
    }, 260);

    input.addEventListener('input', run);
  }

  /* ------------------------------------------------------------------------
     5. GALERIE PRODUS
     ------------------------------------------------------------------------ */
  function initGallery() {
    var gallery = $('[data-gallery]');
    if (!gallery) return;

    var main = $('[data-gallery-main] img', gallery);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.full || thumb.querySelector('img').src;
        main.src = src;
        main.srcset = thumb.dataset.srcset || '';
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ------------------------------------------------------------------------
     6. ACORDEON
     ------------------------------------------------------------------------ */
  function initAccordions() {
    $$('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = trigger.nextElementSibling;
        if (!panel) return;
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.setAttribute('data-open', isOpen ? 'false' : 'true');
      });
    });
  }

  /* ------------------------------------------------------------------------
     7. CANTITATE (cos)
     ------------------------------------------------------------------------ */
  function initQuantity() {
    $$('[data-qty]').forEach(function (wrap) {
      var input = $('input', wrap);
      if (!input) return;

      $$('[data-qty-change]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.qtyChange, 10) || 1;
          var min = parseInt(input.min, 10) || 0;
          var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------------------------
     8. FILTRE COLECTIE (submit automat)
     ------------------------------------------------------------------------ */
  function initFacets() {
    var form = $('[data-facets-form]');
    if (form) {
      form.addEventListener('change', function () { form.submit(); });
    }

    var sort = $('[data-sort-select]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    var toggle = $('[data-facets-toggle]');
    var panel = $('[data-facets-panel]');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var hidden = panel.hasAttribute('hidden');
        if (hidden) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
        toggle.setAttribute('aria-expanded', hidden ? 'true' : 'false');
      });
    }
  }

  /* ------------------------------------------------------------------------
     9. MAGNETIC HOVER (butoane) + TILT (carduri)
     ------------------------------------------------------------------------ */
  function initMagnetic() {
    if (!motionOK || window.matchMedia('(hover: none)').matches) return;

    $$('.magnetic').forEach(function (el) {
      var strength = parseFloat(el.dataset.magnetic || '0.18');

      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * strength;
        var y = (e.clientY - r.top - r.height / 2) * strength;
        el.style.setProperty('--mx', x.toFixed(2) + 'px');
        el.style.setProperty('--my', y.toFixed(2) + 'px');
        el.classList.add('is-hovered');
      });

      el.addEventListener('mouseleave', function () {
        el.classList.remove('is-hovered');
        el.style.setProperty('--mx', '0px');
        el.style.setProperty('--my', '0px');
      });
    });

    $$('.tilt').forEach(function (el) {
      var max = parseFloat(el.dataset.tilt || '5');

      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateX(' + (-py * max).toFixed(2) + 'deg) rotateY(' + (px * max).toFixed(2) + 'deg)';
      });

      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ------------------------------------------------------------------------
     10. PARALLAX SUBTIL
     ------------------------------------------------------------------------ */
  function initParallax() {
    var items = $$('[data-parallax]');
    if (!items.length || !motionOK) return;

    var ticking = false;

    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var speed = parseFloat(el.dataset.parallax) || 0.08;
        var offset = (rect.top + rect.height / 2 - vh / 2) * speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    update();
  }

  /* ------------------------------------------------------------------------
     11. COS — adaugare AJAX + actualizare contor
     ------------------------------------------------------------------------ */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function initCart() {
    $$('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (form.dataset.ajax !== 'true') return;
        e.preventDefault();

        var btn = $('[type="submit"]', form);
        var original = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.innerHTML = '<span class="loader" style="width:18px;height:18px"></span>'; }

        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js');
          })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            if (btn) { btn.innerHTML = btn.dataset.added || 'Adăugat ✓'; }
            if ($('[data-cart-drawer]')) { openDrawer(); refreshDrawer(); }
            setTimeout(function () {
              if (btn) { btn.disabled = false; btn.innerHTML = original; }
            }, 1800);
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.innerHTML = original; }
          });
      });
    });
  }

  /* ------------------------------------------------------------------------
     12. SELECTOR DE VARIANTE
     ------------------------------------------------------------------------ */
  function initVariants() {
    $$('[data-variant-picker]').forEach(function (picker) {
      var data = null;
      try { data = JSON.parse($('[data-variant-json]', picker).textContent); } catch (err) { return; }
      if (!data) return;

      var idInput = $('[data-variant-id]', picker.closest('[data-product-form]') || document);
      var priceEl = $('[data-product-price]');
      var pills = $$('[data-variant-pill]', picker);

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var group = pill.dataset.optionIndex;
          $$('[data-variant-pill][data-option-index="' + group + '"]', picker).forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('aria-pressed', 'false');
          });
          pill.classList.add('is-active');
          pill.setAttribute('aria-pressed', 'true');

          var selected = $$('[data-variant-pill].is-active', picker).map(function (p) { return p.dataset.value; });
          var match = data.find(function (v) {
            return v.options.every(function (opt, i) { return opt === selected[i]; });
          });

          if (match && idInput) {
            idInput.value = match.id;
            if (priceEl && match.price != null) {
              priceEl.textContent = formatMoney(match.price) + ' ' + (priceEl.dataset.currency || '');
            }
          }
        });
      });
    });
  }

  /* ------------------------------------------------------------------------
     13. PAGE LOADER
     ------------------------------------------------------------------------ */
  function initLoader() {
    var loader = $('[data-page-loader]');
    if (!loader) return;
    window.addEventListener('load', function () {
      setTimeout(function () { loader.classList.add('is-done'); }, 220);
    });
    // fallback in caz ca `load` intarzie
    setTimeout(function () { loader.classList.add('is-done'); }, 3500);
  }

  /* ------------------------------------------------------------------------
     14. NEWSLETTER — feedback vizual
     ------------------------------------------------------------------------ */
  function initNewsletter() {
    $$('[data-newsletter-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = $('[type="submit"]', form);
        if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      });
    });
  }


  /* ------------------------------------------------------------------------
     15. CART DRAWER — foloseste Section Rendering API pentru a reincarca
     continutul sertarului fara reload de pagina
     ------------------------------------------------------------------------ */
  function refreshDrawer() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return Promise.resolve();
    var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

    return fetch(root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-drawer-content]');
        var target = $('[data-cart-drawer-content]', drawer);
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        initQuantity();
      })
      .catch(function () {});
  }

  function openDrawer() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
  }

  function closeDrawer() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
  }

  function initDrawer() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;

    $$('[data-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
        refreshDrawer();
      });
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]') || e.target.matches('.drawer__overlay')) closeDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Modificarea cantitatii direct din sertar
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-drawer-qty-input]');
      if (!input) return;
      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: input.dataset.key, quantity: parseInt(input.value, 10) || 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          return refreshDrawer();
        })
        .catch(function () {});
    });
  }

  /* ------------------------------------------------------------------------
     16. BACK TO TOP
     ------------------------------------------------------------------------ */
  function initBackToTop() {
    var btn = $('[data-to-top]');
    if (!btn) return;

    var onScroll = function () {
      btn.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.8);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: prefersReduced ? 'auto' : 'smooth' });
    });
    onScroll();
  }

  /* ------------------------------------------------------------------------
     17. BARA STICKY DE CUMPARARE (mobil, pagina de produs)
     ------------------------------------------------------------------------ */
  function initStickyBuy() {
    var bar = $('[data-sticky-buy]');
    var form = $('[data-product-form]');
    if (!bar || !form) return;

    var onScroll = function () {
      var rect = form.getBoundingClientRect();
      bar.classList.toggle('is-visible', rect.bottom < 0);
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    var btn = $('[data-sticky-add]', bar);
    if (btn) {
      btn.addEventListener('click', function () {
        var submit = $('[type="submit"]', form);
        if (submit) submit.click();
      });
    }

    onScroll();
  }

  /* ------------------------------------------------------------------------
     18. PRODUSE VIZUALIZATE RECENT
     Salvam doar handle-urile in localStorage; randarea se face server-side
     prin Section Rendering API, deci datele raman corecte si traduse.
     ------------------------------------------------------------------------ */
  var RECENT_KEY = 'mihaicr:recently-viewed';

  function readRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }
    catch (e) { return []; }
  }

  function trackRecent() {
    var el = $('[data-track-recent]');
    if (!el || !el.dataset.handle) return;
    var list = readRecent().filter(function (h) { return h !== el.dataset.handle; });
    list.unshift(el.dataset.handle);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }

  function initRecentlyViewed() {
    var holder = $('[data-recently-viewed]');
    if (!holder) return;

    var current = holder.dataset.current || '';
    var limit = parseInt(holder.dataset.limit, 10) || 4;
    var handles = readRecent().filter(function (h) { return h !== current; }).slice(0, limit);

    if (!handles.length) { holder.remove(); return; }

    var query = handles.map(function (h) { return 'handle:' + h; }).join(' OR ');
    var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    var url = root + 'search?type=product&q=' + encodeURIComponent(query) +
      '&section_id=' + holder.dataset.sectionId;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var grid = parsed.querySelector('[data-recent-grid]');
        var target = $('[data-recent-grid]', holder);
        if (grid && target && grid.children.length) {
          target.innerHTML = grid.innerHTML;
          holder.hidden = false;
          initReveal();
        } else {
          holder.remove();
        }
      })
      .catch(function () { holder.remove(); });
  }


  /* ------------------------------------------------------------------------
     19. BARA DE PROGRES LA CITIRE (pagina de articol)
     ------------------------------------------------------------------------ */
  function initReadProgress() {
    var bar = $('[data-read-progress]');
    if (!bar) return;

    var article = $('.article-body');
    if (!article) return;

    var ticking = false;

    function update() {
      var rect = article.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var progress = total > 0 ? (-rect.top / total) : 0;
      progress = Math.min(1, Math.max(0, progress));
      bar.style.width = (progress * 100).toFixed(1) + '%';
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    update();
  }

  /* ------------------------------------------------------------------------
     20. COPIERE LINK (butoanele de distribuire)
     ------------------------------------------------------------------------ */
  function initCopyLink() {
    $$('[data-copy-link]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.dataset.copyLink;
        var done = function () {
          var original = btn.innerHTML;
          btn.innerHTML = '<span style="font-size:.75rem">' + (btn.dataset.copied || 'OK') + '</span>';
          setTimeout(function () { btn.innerHTML = original; }, 1600);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () {});
        } else {
          var tmp = document.createElement('textarea');
          tmp.value = url;
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(tmp);
        }
      });
    });
  }


  /* ------------------------------------------------------------------------
     21. CUPRINSUL ARTICOLULUI
     Se genereaza din titlurile h2/h3 din continut. Fiecare titlu primeste
     un id stabil si o ancora, iar linkul activ se actualizeaza la derulare.
     ------------------------------------------------------------------------ */
  function slugifyHeading(text, used) {
    var base = text
      .toLowerCase()
      .replace(/[ăâ]/g, 'a').replace(/î/g, 'i').replace(/[șş]/g, 's').replace(/[țţ]/g, 't')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60) || 'sectiune';

    var slug = base;
    var i = 2;
    while (used[slug]) { slug = base + '-' + i; i++; }
    used[slug] = true;
    return slug;
  }

  function initTableOfContents() {
    var content = $('[data-article-content]');
    var holders = $$('[data-toc]');
    if (!content || !holders.length) return;

    var headings = $$('h2, h3', content).filter(function (h) {
      return h.textContent.trim().length > 1;
    });

    if (headings.length < 2) {
      holders.forEach(function (h) { h.remove(); });
      return;
    }

    var used = {};
    var items = headings.map(function (h) {
      if (!h.id) h.id = slugifyHeading(h.textContent, used);

      // Ancora vizibila la hover, pentru linkuri directe catre secțiune
      if (!h.querySelector('.heading-anchor')) {
        var a = document.createElement('a');
        a.className = 'heading-anchor';
        a.href = '#' + h.id;
        a.textContent = '#';
        a.setAttribute('aria-label', h.textContent.trim());
        h.appendChild(a);
      }

      return { id: h.id, text: h.textContent.replace(/#$/, '').trim(), level: h.tagName.toLowerCase() };
    });

    holders.forEach(function (holder) {
      var list = $('[data-toc-list]', holder);
      if (!list) return;

      list.innerHTML = items.map(function (item) {
        return '<a class="toc__link' + (item.level === 'h3' ? ' toc__link--sub' : '') +
          '" href="#' + item.id + '" data-toc-link="' + item.id + '">' + item.text + '</a>';
      }).join('');

      holder.hidden = false;
    });

    // Scroll spy
    if (!('IntersectionObserver' in window)) return;

    var links = $$('[data-toc-link]');
    var visible = {};

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visible[entry.target.id] = entry.isIntersecting;
      });

      var currentId = null;
      for (var i = 0; i < items.length; i++) {
        if (visible[items[i].id]) { currentId = items[i].id; break; }
      }

      if (!currentId) return;

      links.forEach(function (link) {
        link.classList.toggle('is-active', link.dataset.tocLink === currentId);
      });
    }, { rootMargin: '-90px 0px -70% 0px', threshold: 0 });

    headings.forEach(function (h) { observer.observe(h); });
  }

  /* ------------------------------------------------------------------------
     22. TABELE RESPONSIVE ÎN ARTICOLE
     Tabelele lipite din editor primesc un container cu derulare orizontala,
     ca sa nu sparga layoutul pe mobil.
     ------------------------------------------------------------------------ */
  function initResponsiveTables() {
    $$('.rte--article table').forEach(function (table) {
      if (table.parentElement && table.parentElement.classList.contains('table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'table-scroll';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  /* ------------------------------------------------------------------------
     23. CUPRINS PLIABIL PE MOBIL
     ------------------------------------------------------------------------ */
  function initTocToggle() {
    $$('[data-toc-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        if (!panel) return;
        var hidden = panel.hasAttribute('hidden');
        if (hidden) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
        btn.setAttribute('aria-expanded', hidden ? 'true' : 'false');
      });
    });

    // Pe mobil, un click pe un link din cuprins inchide panoul
    var mobile = $('.toc--mobile');
    if (!mobile) return;
    mobile.addEventListener('click', function (e) {
      if (!e.target.closest('[data-toc-link]')) return;
      var panel = $('[data-toc-list]', mobile);
      var btn = $('[data-toc-toggle]', mobile);
      if (panel && panel.parentElement) panel.parentElement.setAttribute('hidden', '');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  /* ------------------------------------------------------------------------
     INIT
     ------------------------------------------------------------------------ */
  function init() {
    initLoader();
    initReveal();
    initHeader();
    initMobileMenu();
    initSearch();
    initGallery();
    initAccordions();
    initQuantity();
    initFacets();
    initMagnetic();
    initParallax();
    initCart();
    initVariants();
    initNewsletter();
    initDrawer();
    initBackToTop();
    initStickyBuy();
    trackRecent();
    initRecentlyViewed();
    initReadProgress();
    initCopyLink();
    initTableOfContents();
    initResponsiveTables();
    initTocToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reinitializare in Theme Editor cand o sectiune este reincarcata
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initGallery();
    initAccordions();
    initMagnetic();
    initVariants();
    initCart();
    initDrawer();
    initStickyBuy();
  });
})();
